import { useMutation } from '@tanstack/react-query';
import { deleteGroup } from 'Services';
import { RQ_DELETE_RULE_GROUP } from 'Utils';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';

export default function useDeleteGroup({
    deleteGroupId,
    mutationOptions: { onSuccess, onError }
}: {
    deleteGroupId: number;
    mutationOptions: any;
}) {
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useMutation([RQ_DELETE_RULE_GROUP, deleteGroupId], () => deleteGroup(deleteGroupId, templateRepositoryId!), {
        onSuccess: (data, variables, context) => {
            if (onSuccess) {
                onSuccess(data, variables, context);
            }
        },
        onError: async (error: any, variable, context) => {
            onError?.(error, variable, context);
        }
    });
}
